import { COLORS } from '@avalara/bat-apps-shared/constants';
import styled from 'styled-components';

import { breakpoints } from '../../../lib/constants';

const StyledBox = styled.div`
  margin: auto;

  hr {
    border-color: ${COLORS.disabledGray};
    border-width: 0.5px;
  }

  p, li {
    color: ${COLORS.lighterMediumDarkGray};
  }
`;

export const Info = styled(StyledBox)`
  border: 1px solid ${COLORS.lightGray};
  border-top: 3px solid ${COLORS.lighterMediumDarkGray};
  padding: 20px;

  ul {
    list-style-type: none;
  }

  s-icon {
    line-height: 1.5rem
  }

  p, li {
    color: initial;
  }
`;

export const LightBoxOutline = styled(Info)`
  border: 1px solid ${COLORS.lightGray};
  margin-top: 20px;
  width: fit-content;
  display: inline-block;

  li, i, h4 {
    font-size: .875rem;
  }

  p {
    margin: unset;
  }

  ul {
    list-style: none;
    margin-left: unset;
    margin-top: 1.0em;
  }

  li::before {
    content: "•";
    padding-right: 8px;
    font-size: 18px;
    color: ${COLORS.orange};
  }

  @media (max-width: ${breakpoints.phone}px) {
    width: 100%;
  }
`;

export const GrayBox = styled(StyledBox)`
  background-color: ${COLORS.lightestGray};
  padding: 20px;
  && *:not(a) {
    color: ${COLORS.darkGray};
  }

  && button:not(a) {
    color: ${COLORS.blue};
  }
`;

export const ReviewBox = styled(StyledBox)`
background-color: ${COLORS.grayLightest};
padding: 20px;
p {
  color: ${COLORS.grayBlack};
};
hr {
  border-color: ${COLORS.mediumGray};
  border-width: 0.5px;
}
`;
